<template>

  <b-modal id="ReportNew" size="xl" ref="modal" centered no-close-on-backdrop hide-footer>

    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title">Nuevo Reporte</h5>
      <button type="button" aria-label="Close" class="close" @click="close()">×</button>
    </template>

    <template slot="default" slot-scope="{ hide }">

      <b-form @submit.stop.prevent="crear" ref="form">

        <div class="form-row form-scroll modal_form">

          <div class="col-lg-6 mb-3">
              <label class="form_label_bold" for="browser_first_name">Nombre *</label>
              <b-form-input class="module_dynamic_form_input" autofocus="autofocus" v-model="reporte.nombre" type="text" required :disabled="loading"></b-form-input>
          </div>

          <div class="col-lg-6 mb-3">
              <label class="form_label_bold" for="browser_first_name">Descripción *</label>
              <b-form-input class="module_dynamic_form_input" v-model="reporte.descripcion" type="text" required :disabled="loading"></b-form-input>
          </div>

          <div class="col-lg-6 mb-3">
              <label class="form_label_bold" for="browser_first_name">Entidad *</label>
              <treeselect class="module_dynamic_form_combo" v-model="reporte.entidad" :clearable="false" :disable-branch-nodes="true" placeholder="" 
              :disabled="loading" required :options="entidades" :auto-load-root-options="false" :cache-options="false" :open-on-focus="true"/>
          </div>

        </div>

        <div class="modal-footer" style="padding: 1rem 0rem 0rem 0rem;">
          <button type="button" @click="hide()" class="btn btn-secondary" :disabled="loading">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="loading">Guardar</button>
        </div>

      </b-form>

    </template>
  </b-modal>

</template>

<script>

import Treeselect from '../utils/vue-treeselect/src/components/Treeselect'

export default {
  components: {
    Treeselect
  },
  data () {
    return {
      loading: false,
      reporte: {},
      empresas: [],
      entidades: []
    }
  },
  methods: {
    init (empresa_id) {
       try {
        if (!localStorage.signedIn) {
          this.$router.push('/')
        } else {
          this.reporte.v2_empresa_id = empresa_id
          this.cambioEmpresa(empresa_id)
        } 
      } catch (error) {
        this.showError(error)
      }
      
    },
    cambioEmpresa (empresa){

      var v2_empresa_id = undefined

      if ( empresa.id ) {
        v2_empresa_id = empresa.id
      } else {
        v2_empresa_id = empresa        
      }

      localStorage.empresa_id = v2_empresa_id
      this.reporte.v2_empresa_id = v2_empresa_id

      this.entidades = []
      this.getReportEntidadesPorEmpresa(v2_empresa_id)
        .then(data => {
          this.entidades = data.items
        })
      
    },
    cs (str){
      return str.trim().replace(/'/g, ' ').replace(/"/g, " ").replace(/\t/g, ' ')
    },
    crear () {
      try {
        
        this.$http.secured.post('/desk/client/v1/v2_empresas/'+ this.reporte.v2_empresa_id +'/v2_reportes/', { v2_reporte: this.reporte })
          .then(response => {
            console.log(response)
            this.showOK("Se creó el reporte correctamente!")
            this.$router.push("/report/config/"+ response.data.id)
            this.$emit('closeModal')
            this.$refs.modal.hide()
          })
          .catch(error => {
            this.showError(error)
          })  
      } catch (error) {
        this.showError(error)
      }

    }
  }
}
</script>


